'use strict';

angular.module('ringbaPortal').component('eventCallBackForm', {
  bindings: {
    currentEventCallBack: '<',
    currentEventCallBackParams: '<',
    currentEventCallBackBase: '<',
    onSave: '&',
    onDismiss: '&'
  },
  controller: EventCallBackFormController,
  controllerAs: 'vm',
  templateUrl: '/scripts/shared/components/select-event-callbacks/event-callback-form.view.html'
});

function EventCallBackFormController(
  $filter,
  $scope,
  $timeout,
  $q,
  callbackService,
  accountsService,
  toaster,
  tagService,
  authConnectionService,
  systemFlagsService,
  utils
) {
  'ngInject';

  const vm = this;
  let currentEventCallBack = undefined;
  vm.showFullWidthOptions = {
    showSummaryView: false
  };

  vm.$onInit = onInit;
  vm.appendToken = appendToken;
  vm.cancel = cancel;
  vm.userDefinedMacro = callbackService.userDefinedMacro;
  vm.save = save;
  vm.macros = macros;
  vm.removeAllFilters = removeAllFilters;
  vm.showTagFilterSection = showTagFilterSection;

  vm.onHeadersUpdate = updateHeaders;

  vm.httpMethods = [
    { name: 'GET', value: 'GET' },
    { name: 'POST', value: 'POST' },
    { name: 'PUT', value: 'PUT' },
    { name: 'PATCH', value: 'PATCH' }
  ];

  vm.contentTypes = [
    { name: 'application/json', value: 'application/json' },
    { name: 'application/xml', value: 'application/xml' },
    { name: 'application/x-www-form-urlencoded', value: 'application/x-www-form-urlencoded' },
    { name: 'text/plain', value: 'text/plain' },
  ];

  function onInit() {
    _loadEventCallBackMacros();
    _getTags();
    _getAuthConnections();

    if (vm.currentEventCallBack && vm.currentEventCallBack.id) {
      currentEventCallBack = vm.currentEventCallBack;
      vm.currentEventCallBack = angular.copy(vm.currentEventCallBack);
      if (vm.currentEventCallBack.authConnection && vm.currentEventCallBack.authConnection.id) {
        vm.authenticationConnectionsId = vm.currentEventCallBack.authConnection.id;
      }
    }

    vm.eventCallBackCodes = _availableEventCallBackCodes();

    _checkAndShowTagFilter();
  }

  $scope.$watch('vm.currentEventCallBack.pixelUrl', function (newValue, oldValue) {
    if (newValue && oldValue && newValue.slice(-1) === '=' && newValue.length > oldValue.length) {
      vm.readyForParam = true;
    } else {
      vm.readForParam = false;
    }
  }, true);

  function appendToken(selectedTag) {
    if (selectedTag && selectedTag.originalTag) {
      vm.currentEventCallBack.pixelUrl += selectedTag.originalTag.macro;
    }
    // Wrapping in timeout so everything executes before this and focus is properly set
    $timeout(function () {
      angular.element('#pixel-url').focus();
    });
  }

  function cancel() {
    const eventObj = vm.currentEventCallBack ? {
      eventCallBack: currentEventCallBack
    } : {};
    vm.onDismiss({
      $event: eventObj
    });
  }

  function macros() {
    return callbackService.macros;
  }

  function removeAllFilters() {
    vm.isTagFilterSectionOpen = false;
    vm.currentEventCallBack.criteria = [];
  }

  function showTagFilterSection() {
    vm.isTagFilterSectionOpen = true;
    vm.showFullWidthOptions.showSummaryView = false;
  }


  function updateHeaders(headers) {
    vm.currentEventCallBack.headers = headers;
  }

  function _availableEventCallBackCodes() {
    return callbackService.eventCallBackCodes.filter(function (item) {
      return item.code !== 'analyzed' || systemFlagsService.values.callAnalysis;
    });
  }

  function _checkAndShowTagFilter() {
    if (vm.currentEventCallBack && vm.currentEventCallBack.criteria && vm.currentEventCallBack.criteria.length) {
      vm.isTagFilterSectionOpen = true;
      vm.showFullWidthOptions.showSummaryView = true;
    }
  }

  function _loadEventCallBackMacros() {
    callbackService.getEventCallBackMacros(accountsService.currentAccountId)
      .then(function (response) {
        vm.eventCallBackMacros = response.data.macros;
      })
      .catch(utils.errorHandler);
  }

  function save() {
    if (vm.currentEventCallBack) {
      if (!vm.currentEventCallBack.advanced) {
        vm.currentEventCallBack.method = 'GET';
        vm.currentEventCallBack.headers = {};
      }
      delete vm.currentEventCallBack.advanced;

      if (vm.currentEventCallBack.method === 'GET') {
        vm.currentEventCallBack.postBody = null;
        vm.currentEventCallBack.contentType = null;
      }

      if (!vm.currentEventCallBack.id) {
        return _createEventCallback(vm.currentEventCallBack);
      } else {
        return _updateEventCallback(vm.currentEventCallBack);
      }
    }
  }

  function _createEventCallback(eventCallBack) {
    return callbackService.createEventCallBack(accountsService.currentAccountId, eventCallBack)
      .then(function (response) {
        if (vm.authenticationConnectionsId) {
          callbackService.linkToItem(accountsService.currentAccountId, response.data.eventCallBack.id, {
            memberName: 'AuthConnection',
            memberId: vm.authenticationConnectionsId
          }).then((function () {
            return vm.onSave({
              eventCallback: response.data.eventCallBack,
              newCallback: true
            });
          }));
        } else {
          return vm.onSave({
            eventCallback: response.data.eventCallBack,
            newCallback: true
          });
        }

      })
      .catch(utils.errorHandler);
  }

  function _updateEventCallback(eventCallBack) {
    return callbackService.updateEventCallBack(accountsService.currentAccountId, eventCallBack)
      .then(function () {
        _handleLinkAuthConnection(eventCallBack).then(function () {
          toaster.pop('success', $filter('translate')('PIXELS_UPDATE_SUCCESS'));
          vm.onDismiss({
            $event: {
              eventCallBack: eventCallBack
            }
          });
          vm.onSave();
        });
      })
      .catch(utils.errorHandler);
  }

  function _handleLinkAuthConnection(eventCallBack) {

    if (vm.authenticationConnectionsId) {
      if (!eventCallBack.authConnection || vm.authenticationConnectionsId !== eventCallBack.authConnection.id) {
        return callbackService.linkToItem(accountsService.currentAccountId, eventCallBack.id, {
          memberName: 'AuthConnection',
          memberId: vm.authenticationConnectionsId
        });
      }
    } else {
      if (eventCallBack.authConnection) {
        return callbackService.unLinkItem(accountsService.currentAccountId, eventCallBack.id, {
          memberName: 'AuthConnection',
          memberId: eventCallBack.authConnection.id
        });
      }
    }

    return $q.when();
  }

  function _getTags() {
    tagService.getTags(accountsService.currentAccountId).then(function (response) {
      vm.availableTags = response.data;
    });
  }

  function _getAuthConnections() {
    authConnectionService.getAuthConnections(accountsService.currentAccountId).then(function (response) {
      vm.authConnections = response.data.authConnections;
    });
  }
}
